<style lang="stylus" scoped>
@import '../css/var'
.position
  min-height 100vh
  display flex
  text-align center
.content
  margin auto
.title
  color #8fe2b1
  font-size pt(36)
.icon-class
  color #8fe2b1
  font-size pt(136)
.footer
  height pt(200)
</style>
<template>
  <div class="position">
    <div class="content">
     <i class="icon icon-class">&#xe63c;</i>
    <div class="title">{{titleText}}</div>
    <div class="footer"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    titleText: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>


// WEBPACK FOOTER //
// no-data.vue?7be8be26